<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="Dedication-ded"><span class="ePub-I">You have always been there for me,</span></p>
<p class="Dedication-ded"><span class="ePub-I">and I will always be there for you.</span></p>
<p class="Dedication-ded"><span class="ePub-I">This book is dedicated to you,</span></p>
<p class="Dedication-ded"><span class="ePub-I">whiskey.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?3739ccb2